import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Discover from "../Components/Discover";
import Footer from "../Components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { get_login, get_register } from "../../Services/Operations/ProductAPI";
import { setLoginData, setSignupData } from "../../Redux/user_information";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const SkeletonLoader = () => {
  return (
    <div className="body-container default is-ctl-auth is-act-loginpage">
      
      <main className="content-main" style={{ marginTop: "40px" }}>
        <div className="container">
          <div className="container-main">
            <div className="account-register">
              <div className="row">
                <div className="col-12">
                  <div className="login-register-content-box">
                    <div className="card login-card bgweb">
                      <div className="card-body">

                        <div className="skeleton-title"></div>
                        <div className="skeleton-description"></div>
                        

                        <div className="skeleton-form">
                          <div className="skeleton-input"></div>
                          <div className="skeleton-input"></div>
                          <div className="skeleton-button"></div>
                        </div>
                        
                        <div className="skeleton-title"></div>
                        <div className="skeleton-description"></div>
                        <div className="skeleton-button"></div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="login-advantages col-12">
                  {[1, 2, 3].map((item) => (
                    <div key={item} className="login-advantages-item">
                      <div className="skeleton-icon"></div>
                      <div className="login-advantages-info">
                        <div className="skeleton-advantage-title"></div>
                        <div className="skeleton-advantage-desc"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <style jsx>{`
        .skeleton-title {
          height: 24px;
          width: 70%;
          background: #e0e0e0;
          margin-bottom: 16px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        
        .skeleton-description {
          height: 16px;
          width: 90%;
          background: #e0e0e0;
          margin-bottom: 24px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        
        .skeleton-form {
          margin-bottom: 30px;
        }
        
        .skeleton-input {
          height: 40px;
          background: #e0e0e0;
          margin-bottom: 16px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        
        .skeleton-button {
          height: 48px;
          background: #e0e0e0;
          margin: 20px 0;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        
        .skeleton-icon {
          width: 40px;
          height: 40px;
          background: #e0e0e0;
          border-radius: 50%;
          animation: pulse 1.5s infinite ease-in-out;
          margin-right: 16px;
        }
        
        .skeleton-advantage-title {
          height: 20px;
          width: 80%;
          background: #e0e0e0;
          margin-bottom: 8px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        
        .skeleton-advantage-desc {
          height: 16px;
          width: 90%;
          background: #e0e0e0;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        
        .login-advantages-item {
          display: flex;
          margin-bottom: 20px;
          align-items: center;
        }
        
        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

function SignUp() {
  const [isLoginVisible, setIsLoginVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

    const location = useLocation();

  const from = location.state?.from || "/"; 
  console.log("from : ",from)

  const toggleForms = () => {
    setIsLoginVisible((prev) => !prev);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      alert("Enter all fields");
    } else {
      try {
        const result = await get_login({ email, password });
        console.log("login data : ", result);
        if (result.success === true) {
          dispatch(setLoginData(result.data.access_token));
          setName("");
          setEmail("");
          setPassword("");
          toast.success(result.message);
          // navigate("/");
          const from = location.state?.from || "/";
      navigate(from);
        } else {
          toast.error(result.message);
        }
      } catch (error) {
        console.error("Signin error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!name.trim() || !email.trim() || !password.trim()) {
      alert("Enter all fields");
    } else {
      try {
        const result = await get_register({ name, email, password });
        if (result.success === true) {
          toast.success(result.message);
          dispatch(setLoginData(result.data.access_token));
          setName("");
          setEmail("");
          setPassword("");
           navigate("/");
        } else {
          toast.error(result.message);
        }
        console.log("register data : ", result);
      } catch (error) {
        console.error("Signup error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  if (isLoading) {
    return <SkeletonLoader />;
  }

  return (
    <div className="body-container default is-ctl-auth is-act-loginpage">
      <div>
        

        <main className="content-main" style={{ marginTop:window.innerWidth<567?"80px": "80px" }}>
          <div data-flashbags-container="true" className="flashbags"></div>
          <div className="container">
            <div className="container-main">
              <div className="account-register">
                <div className="row">
                  <div className="col-12">
                    <div className="login-register-content-box" id="loginForm">
                      <div className="card login-card bgweb">
                        <div className="card-body">
                          <div className="card-title middle1">
                            {isLoginVisible
                              ? "I'm already a customer."
                              : "I'm a new customer!"}
                          </div>
                          <p className="login-form-description default small1" style={{ fontSize: "1rem" }}>
                            {isLoginVisible
                              ? "Log in with your email address and password."
                              : "Register here with your data."}
                          </p>

                          {/* Login Form */}
                          {isLoginVisible && (
                            <div id="collapseLogin" className="show">
                              <form className="login-form" method="post" data-form-validation="true">
                                <input type="hidden" name="redirectTo" value="frontend.account.home.page" />
                                <input type="hidden" name="redirectParameters" value="[]" />
                                <div className="row g-2">
                                  <div className="form-group col-md-6 small1">
                                    <label className="form-label" htmlFor="loginMail">
                                      Your email address
                                    </label>
                                    <input
                                      className="form-control"
                                      id="loginMail"
                                      type="email"
                                      placeholder="Enter Email"
                                      required
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                    />
                                  </div>
                                  <div className="form-group col-md-6">
                                    <label className="form-label small1" htmlFor="loginPassword">
                                      Your password
                                    </label>
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="loginPassword"
                                      placeholder="Password"
                                      required
                                      value={password}
                                      onChange={(e) => setPassword(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="login-submit">
                                  <button
                                    type="submit"
                                    className="btn-collapse button6 btn-outline button-big"
                                    style={{
                                      backgroundColor: "black",
                                      color: "white",
                                      fontSize: "20px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <div
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          border: "3px solid rgba(255, 255, 255, 0.3)",
                                          borderTopColor: "#fff",
                                          borderRadius: "50%",
                                          animation: "spin 1s linear infinite",
                                        }}
                                      ></div>
                                    ) : (
                                      " Sign in"
                                    )}
                                  </button>
                                </div>
                                <div className="login-password-recover small1">
                                  <a onClick={() => navigate("/forgot-password")}>
                                    Forgot your password?
                                  </a>
                                </div>
                              </form>
                            </div>
                          )}

                          {/* Register Form */}
                          {!isLoginVisible && (
                            <div id="collapseRegister">
                              <form className="register-form" method="post" data-form-validation="true">
                                <div className="register-personal small">
                                  <div className="row g-2">
                                    <div className="form-group col-sm-6">
                                      <label className="form-label small1" htmlFor="personalMail">
                                        Your name*
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        autoComplete="section-personal given-name"
                                        id="personalFirstName"
                                        placeholder="Enter your name..."
                                        name="name"
                                        required="required"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                      />
                                    </div>
                                    <div className="form-group col-sm-6">
                                      <label className="form-label small1" htmlFor="personalMail">
                                        Your email address*
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control"
                                        autoComplete="section-personal email"
                                        id="personalMail"
                                        placeholder="Enter email address..."
                                        name="email"
                                        required="required"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                      />
                                    </div>
                                    <div className="form-group col-sm-6">
                                      <label className="form-label small1" htmlFor="personalPassword">
                                        Password*
                                      </label>
                                      <input
                                        type="password"
                                        className="form-control"
                                        autoComplete="new-password"
                                        id="personalPassword"
                                        placeholder="Enter password..."
                                        name="password"
                                        minLength="8"
                                        required="required"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                      />
                                      <small className="form-text js-validation-message small1">
                                        Your password must contain at least 8 characters.
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div className="register-submit button-big" style={{ marginBottom: "50px" }}>
                                  <button
                                    type="submit"
                                    className="btn-collapse button6 btn-outline button-big"
                                    style={{
                                      backgroundColor: "black",
                                      color: "white",
                                      fontSize: "20px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onClick={handleRegisterSubmit}
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <div
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          border: "3px solid rgba(255, 255, 255, 0.3)",
                                          borderTopColor: "#fff",
                                          borderRadius: "50%",
                                          animation: "spin 1s linear infinite",
                                        }}
                                      ></div>
                                    ) : (
                                      "Submit"
                                    )}
                                  </button>
                                </div>
                              </form>
                            </div>
                          )}
                          
                          {/* Toggle Button */}
                          <div className="card-title middle1">
                            {isLoginVisible
                              ? "I'm a new customer."
                              : "I'm already a customer!"}
                          </div>
                          <p className="login-form-description default small1" style={{ fontSize: "1rem" }}>
                            {isLoginVisible
                              ? "Register here with your data."
                              : "Log in with your email address and password."}
                          </p>
                          <button
                            onClick={toggleForms}
                            className="btn-collapse button6 btn-outline button-big"
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              fontSize: "20px",
                              display: "flex",
                              alignItems: 'center',
                              justifyContent: "center"
                            }}
                          >
                            {isLoginVisible ? "Sign up" : "Sign in"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Additional Information */}
                  <div className="login-advantages col-12">
                    <div className="login-advantages-item">
                      <div className="login-advantages-info">
                        <div className="login-advantages-title middle1" style={{ fontSize: "1.5rem" }}>
                          All printing costs included
                        </div>
                        <div className="login-advantages-description small1" style={{ fontSize: "1rem" }}>
                          No additional costs for logos, numbers or names
                        </div>
                      </div>
                    </div>
                    <div className="login-advantages-item">
                      <div className="login-advantages-info">
                        <div className="login-advantages-title middle1" style={{ fontSize: "1.5rem" }}>
                          Safe and fast delivery
                        </div>
                        <div className="login-advantages-description small1" style={{ fontSize: "1rem" }}>
                          Speed is not only important in sport. We deliver as fast as possible.
                        </div>
                      </div>
                    </div>
                    <div className="login-advantages-item">
                      <div className="login-advantages-info">
                        <div className="login-advantages-title middle1" style={{ fontSize: "1.5rem" }}>
                          EU, UK, Switzerland
                        </div>
                        <div className="login-advantages-description small1" style={{ fontSize: "1rem" }}>
                          We ship within the EU, Switzerland and UK
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default SignUp;